<template>
  <div class="box">
    <div class="title fs15">
      <p>公司信息表单</p>
    </div>
    <div class="main">
      <div>
        <!-- 基础信息 -->
        <div class="wrpa1">
          <!-- <h3>基础信息</h3> -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item label="公司名称" prop="e_name">
              <el-input v-model="ruleForm.e_name" placeholder="请填写公司名称"></el-input>
            </el-form-item>
            <el-form-item label="行业类型" prop="trade">
              <el-select v-model="ruleForm.trade" @change="selTrade" placeholder="请选择行业类型">
                <el-option v-for="item in tradeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在区域" class="area" required>
              <el-row :gutter="20" style="margin-bottom:0">
                <el-col :span="7">
                  <el-form-item prop="xixun_province_id">
                    <el-select v-model="ruleForm.xixun_province_id" placeholder="请选择省份" @change="changeProvince">
                      <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="xixun_city_id">
                    <el-select v-model="ruleForm.xixun_city_id" placeholder="请选择市" @change="changeCity">
                      <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="xixun_county_id">
                    <el-select v-model="ruleForm.xixun_county_id" placeholder="请选择区县" @change="changeCounty">
                      <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="ruleForm.address" placeholder="请填写详细地址"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="uscc">
              <el-input v-model="ruleForm.uscc" placeholder="请填写统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contact_name">
              <el-input v-model="ruleForm.contact_name" placeholder="请填写联系人"></el-input>
            </el-form-item>
            <el-form-item label="职位">
              <el-input v-model="ruleForm.contact_job" placeholder="请填写职位"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="contact_mob">
              <el-input v-model="ruleForm.contact_mob" placeholder="请填写手机号码"></el-input>
            </el-form-item>
            <!-- <el-form-item label="QQ">
              <el-input v-model="ruleForm.contact_qq" placeholder="请填写QQ"></el-input>
            </el-form-item> -->
            <el-form-item label="邮箱">
              <el-input type="email" v-model="ruleForm.contact_email" placeholder="请填写邮箱"></el-input>
            </el-form-item>
            <!-- <h3>公司详情</h3> -->
            <!-- <el-form-item label="电话" prop="tel">
              <el-input v-model="ruleForm.tel" placeholder="请填写电话"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="传真">
              <el-input v-model="ruleForm.fax" placeholder="请填写传真"></el-input>
            </el-form-item> -->
            <el-form-item label="网址">
              <el-input v-model="ruleForm.site" placeholder="请填写网址"></el-input>
            </el-form-item>
            <el-form-item label="公司介绍"  prop="brief">
              <el-input :autosize="{ minRows: 5, maxRows: 8 }" type="textarea" v-model="ruleForm.brief" placeholder="请输入介绍信息"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="next('ruleForm')">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validUscc } from "@/assets/js/validate";
import formatter from "@/assets/js/mixins/formatter"; // 公用函数

export default {
  mixins: [formatter],
  data() {
    return {
      ruleForm: {
        // id: "",
        e_name: "",
        trade: "",
        xixun_province_id: "",
        xixun_city_id: "",
        xixun_county_id: "",
        uscc: "",
        contact_name: "",
        contact_job: "",
        contact_mob: "",
        contact_qq: "",
        contact_email: "",
        address: "",
        tel: "",
        fax: "",
        site: "",
        brief: ""
      },
      provinceList: "",
      cityList: "",
      countyList: "",
      province: "",
      city: "",
      county: "",
      trade: "",
      tradeList: "",
      // 验证规则
      rules: {
        e_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        trade: [
          { required: true, message: "请选择行业类型", trigger: "change" }
        ],
        xixun_province_id: [
          { required: true, message: "请选择所在省份", trigger: "change" }
        ],
        xixun_city_id: [
          { required: true, message: "请选择所在城市", trigger: "change" }
        ],
        xixun_county_id: [
          { required: true, message: "请选择所在区县", trigger: "change" }
        ],
        uscc: [{ required: true, trigger: "blur", validator: validUscc }],
        contact_name: [
          { required: true, message: "请填写联系人", trigger: "blur" }
        ],
        brief: [
          { required: true, message: "请填写企业介绍", trigger: "blur" }
        ],
        contact_mob: [
          { required: true, message: "请填写手机号码", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请填写详细地址", trigger: "blur" }
        ]
      },
      // 操作类型
      operationType: ""
    };
  },
  mounted() {
    this.getTrade(); // 行业类型
    this.getProvince(); // 所在区域
    this.getInfo(); // 获取企业基本信息
  },
  watch: {
    // "ruleForm.xixun_province_id": function() {
    //   this.ruleForm.xixun_city_id = null;
    //   this.ruleForm.xixun_county_id = null;
    // },
    // "ruleForm.xixun_city_id": function() {
    //   this.ruleForm.xixun_county_id = null;
    // }
  },
  methods: {
    async getInfo() {
      let res = await this.$api.info.get();
      if (res.code === 0) {
        if (res.data.length === 0) {
          this.operationType = "add";
          return;
        }
        let item = res.data[0];
        // this.ruleForm.id = item.id;
        this.ruleForm.e_name = item.e_name;
        this.ruleForm.trade = Number(item.trade);
        this.ruleForm.xixun_province_id = item.xixun_province_id;
        this.ruleForm.xixun_city_id = item.xixun_city_id;

        this.ruleForm.xixun_county_id = item.xixun_county_id;

        this.ruleForm.uscc = item.uscc;
        this.ruleForm.contact_name = item.contact_name;
        this.ruleForm.contact_job = item.contact_job;
        this.ruleForm.contact_mob = item.contact_mob;
        this.ruleForm.contact_qq = item.contact_qq;
        this.ruleForm.contact_email = item.contact_email;
        this.ruleForm.address = item.address;
        this.ruleForm.tel = item.tel;
        this.ruleForm.fax = item.fax;
        this.ruleForm.site = item.site;
        this.ruleForm.brief = item.brief;
        this.ruleForm.logo_image = item.logo_image;
        this.ruleForm.bl_image = item.bl_image;

        // item.xixun_province_id ? this.changeProvince(item.xixun_province_id) : ''
        // item.xixun_city_id ? this.changeCity(item.xixun_city_id) : ''
        // item.xixun_county_id ? this.changeCounty(item.xixun_county_id) : ''

        item.xixun_province_id ? this.getCity(item.xixun_province_id) : "";
        item.xixun_city_id ? this.getCounty(item.xixun_city_id) : "";
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    },
    async getTrade() {
      let res = await this.$api.common.getTrade();
      this.tradeList = res.data;
    },
    async getProvince() {
      let res = await this.$api.common.getXixunProvince();
      if (res.code === 0) {
        this.provinceList = res.data;
      }
    },
    async getCity(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    async getCounty(cityId) {
      let res = await this.$api.common.getXixunCounty(cityId);
      if (res.code === 0) {
        this.countyList = res.data;
      }
    },
    changeProvince(provinceId) {
      this.ruleForm.xixun_city_id = null;
      this.ruleForm.xixun_county_id = null;
      this.getCity(provinceId);

      // let obj = {}
      // obj = this.provinceList.find(item => {
      //   return item.id === val;
      // });
      // this.province = obj.name;
    },
    changeCity(cityId) {
      this.ruleForm.xixun_county_id = null;
      this.getCounty(cityId);

      // let obj = {};
      // obj = this.cityList.find(item => {
      //   return item.id === val
      // });
      // this.city = obj.name;
    },
    changeCounty(val) {
      // let obj = {}
      // obj = this.countyList.find(item => {
      //   return item.id === val
      // })
      // this.county = obj.name
    },
    selTrade(vId) {
      let obj = {};
      obj = this.tradeList.find(item => {
        return item.id === vId; //筛选出匹配数据
      });
      this.trade = obj.value;
    },
    next(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.selTrade(this.ruleForm.trade);
          let ruleForm = {
            e_name: this.ruleForm.e_name,
            trade: this.trade,
            province: this.province,
            city: this.city,
            county: this.county,
            uscc: this.ruleForm.uscc,
            contact_name: this.ruleForm.contact_name,
            contact_mob: this.ruleForm.contact_mob
            // logo_image:
          };
          this.$store.commit("reg", ruleForm);

          if (this.operationType === "add") {
            this.addInfo();
          } else {
            this.updateInfo();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addInfo() {
      let res = await this.$api.info.add(this.ruleForm);
      if (res.code === 0) {
        this.$message({
          message: "成功",
          type: "success",
          center: true
        });
        localStorage.setItem("id", res.data.id);
        this.$emit("changeActive");
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    },
    async updateInfo() {
      let params = this.ruleForm;
      // params= this.delNullVal(params);
      // console.log(params)
      let res = await this.$api.info.update(params);
      if (res.code === 0) {
        this.$message({
          message: "成功",
          type: "success",
          center: true
        });
        this.$emit("changeActive");
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  margin: 0 auto;
  border: 1px solid #e9e9e9;
  max-width: 960px;
  color: #999999;
  .title {
    max-width: 960px;
    height: 50px;
    font-weight: 700;
    line-height: 28px;
    border-bottom: 1px solid #e9e9e9;
    background: #fff;
    p {
      height: 100%;
      line-height: 50px;
      padding-left: 20px;
    }
  }
  .main {
    text-align: center;
    margin: 0 auto;
    padding: 30px 0;
    background: #fff;
    .area {
      .el-form-item {
        margin: 0;
        width:100%;
        .el-select {
          width: 100%;
        }
      }
    }
    h3 {
      padding: 0 40px;
      text-align: left;
      margin-bottom: 30px;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-form-item {
      width: 70%;
      margin-left: auto;
      margin-right: auto;
    }
    .el-select {
      width: 100%;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>